import pick from 'lodash/pick';

import {QueryReportHeaderParams, QueryReportHeaderSave} from 'common/query-builder/query-report-header/types';
import {QueryReportTitleProps} from 'common/query-builder/query-report-title/types';

export function headerParamsToTitleProps(
  headerParams: QueryReportHeaderParams & {onSave: (params: QueryReportHeaderSave) => void},
): QueryReportTitleProps {
  return {
    ...pick(headerParams, [
      `allowStaffOverride`,
      `canSave`,
      `canWrite`,
      `displayContext`,
      `emptyEntityName`,
      `hasUnsavedChanges`,
      `invalidEntity`,
      `isSuperadmin`,
      `onSave`,
      `projectId`,
      `selectedEntityId`,
      `trackName`,
      `workspaceId`,
    ]),
    entityName: headerParams.selectedEntityName,
    entityDescription: headerParams.selectedEntityDescription,
  };
}
